var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 40,
    viewBox: "0 0 122 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1417_13622",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 122,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1432 20.7101C52.1432 26.3721 47.6289 30.5443 42.0887 30.5443C36.5486 30.5443 32.0342 26.3721 32.0342 20.7101C32.0342 15.0083 36.5486 10.876 42.0887 10.876C47.6289 10.876 52.1432 15.0083 52.1432 20.7101ZM47.7418 20.7101C47.7418 17.172 45.1254 14.7511 42.0887 14.7511C39.052 14.7511 36.4356 17.172 36.4356 20.7101C36.4356 24.2128 39.052 26.6691 42.0887 26.6691C45.1254 26.6691 47.7418 24.2084 47.7418 20.7101Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8337 20.7101C73.8337 26.3721 69.3193 30.5443 63.7791 30.5443C58.239 30.5443 53.7246 26.3721 53.7246 20.7101C53.7246 15.0127 58.239 10.876 63.7791 10.876C69.3193 10.876 73.8337 15.0083 73.8337 20.7101ZM69.4323 20.7101C69.4323 17.172 66.8158 14.7511 63.7791 14.7511C60.7424 14.7511 58.126 17.172 58.126 20.7101C58.126 24.2128 60.7424 26.6691 63.7791 26.6691C66.8158 26.6691 69.4323 24.2084 69.4323 20.7101Z",
    fill: "#FBBC05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6216 11.4701V29.1254C94.6216 36.388 90.2563 39.3542 85.0957 39.3542C80.2379 39.3542 77.3142 36.1663 76.2116 33.5592L80.0436 31.9941C80.726 33.5947 82.398 35.4835 85.0912 35.4835C88.3945 35.4835 90.4416 33.4839 90.4416 29.7196V28.3052H90.2879C89.3028 29.4979 87.4049 30.5398 85.0099 30.5398C79.9984 30.5398 75.4072 26.2568 75.4072 20.7456C75.4072 15.1945 79.9984 10.876 85.0099 10.876C87.4004 10.876 89.2983 11.9179 90.2879 13.0751H90.4416V11.4745H94.6216V11.4701ZM90.7534 20.7456C90.7534 17.2828 88.3991 14.7511 85.403 14.7511C82.3663 14.7511 79.8222 17.2828 79.8222 20.7456C79.8222 24.1729 82.3663 26.6691 85.403 26.6691C88.3991 26.6691 90.7534 24.1729 90.7534 20.7456Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.512 1.12207V29.9417H97.2188V1.12207H101.512Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.242 23.9473L121.658 26.1819C120.556 27.7825 117.899 30.5404 113.307 30.5404C107.614 30.5404 103.361 26.2218 103.361 20.7062C103.361 14.858 107.65 10.8721 112.815 10.8721C118.016 10.8721 120.56 14.9334 121.392 17.1281L121.848 18.2455L108.45 23.6901C109.475 25.6632 111.071 26.6697 113.307 26.6697C115.549 26.6697 117.103 25.5878 118.242 23.9473ZM107.727 20.4091L116.683 16.7601C116.19 15.532 114.708 14.6763 112.964 14.6763C110.727 14.6763 107.614 16.6138 107.727 20.4091V20.4091Z",
    fill: "#EA4335"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7845 18.1519V13.9797H30.1139C30.254 14.7069 30.3263 15.567 30.3263 16.4981C30.3263 19.6284 29.4541 23.4991 26.6434 26.2569C23.9095 29.0502 20.4164 30.5399 15.789 30.5399C7.21215 30.5399 0 23.6853 0 15.27C0 6.85463 7.21215 0 15.789 0C20.5338 0 23.914 1.82672 26.4536 4.20766L23.453 7.1517C21.6319 5.47573 19.1646 4.17219 15.7845 4.17219C9.5213 4.17219 4.62283 9.12473 4.62283 15.27C4.62283 21.4152 9.5213 26.3677 15.7845 26.3677C19.847 26.3677 22.1606 24.7671 23.6428 23.3129C24.8449 22.1335 25.6357 20.4486 25.9475 18.1475L15.7845 18.1519V18.1519Z",
    fill: "#4285F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1417_13622)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.60645,
    y: -1.55957,
    width: 134.593,
    height: 41,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.0b0f36fb245f70570024e055effad838.svg";
export { ForwardRef as ReactComponent };